// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { FlatList, View, ActivityIndicator, Text } from "react-native";
import { Snackbar } from "react-native-paper";
import RequestCard from "../../components/Shadows/Carrier/RequestCard";
import FilterButtons from "../../components/Shadows/Carrier/Elements/FilterButtons";
import colors from "../../config/colors";
import { fetchTransportGroupList } from "../../axios/axiosConfig";
import AsyncStorage from "@react-native-async-storage/async-storage";
import logger from "../../axios/loggingConfig";
import fonts from "../../config/fonts";

const RequestsScreen = ({
    getTranslation,
    formatDate,
    fetchActiveRequests,
}) => {
    const [requestsData, setRequestsData] = useState([]);
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErrorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [reload, setReload] = useState(false);

    const fetchData = async () => {
        try {
            const requestResponse = await fetchTransportGroupList();
            if (requestResponse.status === 200) {
                setRequestsData(requestResponse.data);
            }
        } catch (error) {
            logger.error("Error in fetchRequests(Driver) : " + error);
            setErrorMessage(error.message || "Failed to fetch data.");
            setErrorVisible(true);
        } finally {
            setLoading(false);
        }
    };

    const handleShowSnackbar = (message, color) => {
        setErrorMessage(getTranslation(message));
        setErrorVisible(color);
    };

    useEffect(() => {
        const handleBlur = () => {
            setReload((prev) => !prev);
        };
        window.addEventListener("blur", handleBlur);
        return () => {
            window.removeEventListener("blur", handleBlur);
        };
    }, []);

    useEffect(() => {
        AsyncStorage.getItem("userData").then((userData) => {
            const userDataObject = JSON.parse(userData);
            if (userDataObject && userDataObject.landingView === "Driver") {
                fetchData();
                fetchActiveRequests();
            } else {
                setLoading(false);
            }
        });
    }, [reload]);

    const filteredRequests =
        filter === ""
            ? requestsData
            : requestsData.filter((item) =>
                filter === "Auto"
                    ? item.type === "Automatic"
                    : filter === getTranslation("Manuali")
                        ? item.type === "Manual"
                        : filter === getTranslation("Clienti") && item.type === "Customer"
            );

    const handleFilterPress = (selectedFilter) => {
        setFilter((prevFilter) =>
            prevFilter === selectedFilter ? "" : selectedFilter
        );
    };

    return (
        <View style={{ flex: 1, backgroundColor: colors.green }}>
            {loading ? (
                <ActivityIndicator
                    size="large"
                    color={colors.white}
                    style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
                />
            ) : (
                <>
                    <FilterButtons
                        selectedFilter={filter}
                        onPressFilter={handleFilterPress}
                        getTranslation={getTranslation}
                    />
                    {filteredRequests.length === 0 ? (
                        <View
                            style={{
                                flex: 1,
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "white",
                                    fontFamily: fonts.regular
                                }}
                            >
                                {getTranslation("Nessuna richiesta presente")}
                            </Text>
                        </View>
                    ) : (
                        <FlatList
                            data={filteredRequests}
                            renderItem={({ item }) => (
                                <RequestCard
                                    item={item}
                                    getTranslation={getTranslation}
                                    handleShowSnackbar={handleShowSnackbar}
                                />
                            )}
                            keyExtractor={(item) => item.id.toString()}
                            contentContainerStyle={{ paddingBottom: 20, marginTop: 5 }}
                        />
                    )}
                </>
            )}
            <Snackbar
                visible={errorVisible}
                onDismiss={() => setErrorVisible(false)}
                action={{
                    label: "OK",
                    onPress: () => {
                        setErrorVisible(false);
                    },
                    textColor: "white",
                }}
                style={{ backgroundColor: "red", color: "white" }}
            >
                {errorMessage}
            </Snackbar>
        </View>
    );
};

export default RequestsScreen;
